<h1 mat-dialog-title class="p-2 text-center">Ajout de mesures complémentaires</h1>
<div mat-dialog-content class="p-3">
    <div class="row g-0 justify-content-center">
        <mat-form-field class="col">
            <mat-select placeholder="Selectionnez une mesure" [(ngModel)]="SelectedMeasureReference" required>
                @for (m of MeasureReferenceList; track m) {
                <mat-option [value]="m">
                    @if (strategyType !== EStrategyType.FDX) {
                    <span> {{m.Code }} - {{m.Designation}}</span>
                    }
                    @if (strategyType === EStrategyType.FDX) {
                    <span> {{m.Designation }} </span>
                    }
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <input matInput placeholder="Nombre de mesures" type="number" [(ngModel)]="MeasureCount">
        </mat-form-field>
    </div>
    <div class="row g-0 justify-content-center">
        <mat-form-field class="col">
            <mat-select placeholder="Selectionnez un plan" [(ngModel)]="this.Model.AreaMapName">
                @for (m of AreaMapList; track m) {
                <mat-option [value]="m.Legend">
                    <span>{{m.Legend}} </span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <input matInput placeholder="Description" [(ngModel)]="this.Model.ParentDescription">
        </mat-form-field>
    </div>

    <!-- <div *ngIf="IsDispatch" class="row no-gutters justify-content-center my-3">
  <div class="col">
    <mat-form-field class="w-100">
      <input matInput placeholder="EDI Analysis Number" [(ngModel)]="this.Model.EDIAnalysisNumber">
    </mat-form-field>
  </div>
</div> -->

    <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="this.Model.PumpWithBattery">
        Batterie*
    </mat-slide-toggle>

    <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="this.Model.Rush">
        Express*
    </mat-slide-toggle>

    @if (IsDispatch) {
    <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="this.Model.HasFan">
        Ventilateur*
    </mat-slide-toggle>
    }

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanAdd()">
            Ajouter
        </button>
    </div>
</div>